import Vue from 'vue'
import router from './router'
import axios from 'axios'
import GlobalStorePlugin from './globalStorePlugin'
import GlobalFromValidationPlugin from './globalFromValidationPlugin'

import { store } from './store/store'
import vuetify from './plugins/vuetify'
import { geolocation } from './plugins/geolocation'
import VueGtag from 'vue-gtag'

import App from './App.vue'
import ENV_CONSTANTS from '../src/config/envVariables'

// Use global store plugin.
Vue.use(GlobalStorePlugin)
Vue.use(geolocation)

// Use global store plugin.
Vue.use(GlobalFromValidationPlugin)

/**
* Configure axios
*/
axios.defaults.withCredentials = true
axios.defaults.baseURL = ENV_CONSTANTS.INTERNAL_API_BASE_ENDPOINT
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.post['Accept'] = 'application/json'
axios.interceptors.request.use(
  config => {
    // modify headers
    if (store.state.AuthModule.token && !config.url.includes('maps.googleapis')) {
      // exclude Authorization header to external API calls
      config.headers.common['Authorization'] = `Bearer ${store.state.AuthModule.token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched (accessToken) {
  subscribers = subscribers.filter(callback => callback(accessToken))
}

function addSubscriber (callback) {
  subscribers.push(callback)
}

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  const { config, response: { status } } = error
  const originalRequest = config
  if (status === 401 && config.url === '/login') {
    return Promise.reject(error)
  } else if (status === 401 && config.url !== '/api/v1/token/refresh') {
    if (!isAlreadyFetchingAccessToken) {
      isAlreadyFetchingAccessToken = true
      new Promise((resolve, reject) => {
        store.dispatch('AuthModule/refresh', { resolve, reject })
      }).then((accessToken) => {
        isAlreadyFetchingAccessToken = false
        onAccessTokenFetched(accessToken)
      })
    }

    const retryOriginalRequest = new Promise((resolve) => {
      addSubscriber(accessToken => {
        originalRequest.headers.Authorization = 'Bearer ' + accessToken
        resolve(axios(originalRequest))
      })
    })
    return retryOriginalRequest
  } else if (status === 401 && (config.url === '/api/v1/token/refresh' || !localStorage.getItem('keepLoggedIn'))) {
    isAlreadyFetchingAccessToken = false
    subscribers = []
    new Promise((resolve, reject) => {
      store.dispatch('AuthModule/logout', { resolve, reject })
    }).then(() => {
      // if current route is not AdminLogin, then redirect user to login
      // otherwise system will geterate exception NavigationDuplicated
      if (router.currentRoute.name !== 'AdminLogin') {
        router.push({ name: 'AdminLogin' })
      }
    }).catch(() => {
      if (router.currentRoute.name !== 'AdminLogin') {
        router.push({ name: 'AdminLogin' })
      }
    })
  }
  return Promise.reject(error)
})
Vue.prototype.$axios = axios
Vue.config.productionTip = false

// Code for Google Analytics
// First identify the env for setting correct tracking id
let trackingId = ''
if (ENV_CONSTANTS.APP_ENV === 'STAGE') {
  trackingId = ENV_CONSTANTS.GA_TRACK_ID_BY_ENV.STAGE
}
if (ENV_CONSTANTS.APP_ENV === 'PROD') {
  trackingId = ENV_CONSTANTS.GA_TRACK_ID_BY_ENV.PROD
}
if (ENV_CONSTANTS.APP_ENV === 'DEV') {
  trackingId = ENV_CONSTANTS.GA_TRACK_ID_BY_ENV.DEV
}
// pass correct traking code
Vue.use(VueGtag, {
  config: { id: trackingId }
}, router)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
